var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',[_c('t-header',{attrs:{"header":_vm.header}}),_c('tbody',_vm._l((_vm.raws),function(raw,$index){return _c('t-row',{key:$index,attrs:{"raw":raw},on:{"editOxilio":_vm.edit,"remove":_vm.remove}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }